import { enhancedApi } from '@store/generated/container';

const SERVER_UI_TAG_TYPES = ['ServerUi', 'ServerUiComponent'] as const;

export const serverUiApi = enhancedApi.enhanceEndpoints({
  addTagTypes: SERVER_UI_TAG_TYPES,
  endpoints: {
    getV2ProviderContainersByContainerKey: {
      providesTags: (result, _error, { containerKey, entityId }) =>
        result
          ? [{ type: 'ServerUi' as const, id: `${containerKey}:${entityId ?? 'global'}` }]
          : [],
    },
    getV2ProviderContainersByContainerKeyComponentsAndTypeKey: {
      providesTags: (result, _error, { containerKey, typeKey, entityId }) =>
        result
          ? [
              {
                type: 'ServerUiComponent' as const,
                id: `${containerKey}:${typeKey}:${entityId ?? 'global'}`,
              },
            ]
          : [],
    },
    // NOTE: No invalidatesTags on mutations. Invalidation is handled manually
    // in the click handlers via api.util.invalidateTags() to avoid double-refetch
    // caused by dynamicMiddleware re-entering RTK Query's middleware chain.
    postV2ProviderContainersByContainerKeyComponentsAndTypeKeyActionsActionKey: {},
    postV2ProviderContainersByContainerKeyComponentsAndTypeKeyDismiss: {},
  },
});

export const {
  useGetV2ProviderContainersByContainerKeyQuery: useGetServerUiQuery,
  useGetV2ProviderContainersByContainerKeyComponentsAndTypeKeyQuery: useGetServerUiComponentQuery,
  usePostV2ProviderContainersByContainerKeyComponentsAndTypeKeyActionsActionKeyMutation:
    useDispatchTileActionMutation,
  usePostV2ProviderContainersByContainerKeyComponentsAndTypeKeyDismissMutation:
    useDismissComponentMutation,
} = serverUiApi;
